
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HandleService } from '../../../../_services/handle.service';
import { isNullOrEmptyString, isNullOrUndefined } from '../../../../_helpers';


@Component({
    selector: 'pop-product-compositions',
    templateUrl: './popin-product-compositions.component.html',
    styleUrls: ['./popin-product-compositions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PopinProductCompositionsComponent implements OnInit {

    // #region config
    // Liste des compositions ordonnées gérées affichées
    private _orderedCompos = ['N', 'P2O5', 'K2O', 'MgO', 'CaO', 'SO3'];
    //Unité de composition par masse
    private _compoMassUnit = 'kg/100 kg';
    //Unité de composition par litre
    private _compoLiquidUnit = 'kg/100 l';
    //Unité de composition du produit
    private _compoUnit = this._compoMassUnit;
    //Préfixe du tooltip sur ptoduit
    private _pfxTooltip: string = "Composition de l'engrais ";

    //Css de base sur la div avec le hover géré
    private _basicDivClassHover = "dv-popin-product-compositions";

    //valeur affichée en cas de composition absente au produit
    private _noneCompoValue = "0";
    //#endregion

    //#region Paramétrages

    /**true indique que on ne prend en compte que les teneurs souhaitées avec une valeur présente supérieur à 0, false toutes les valeurs présentes  */
    private _onlyWithCompo = true;

    /**true même si non présent on affiche la teneur à 0  */
    private _forceOnEmpty = false;
    //#endregion

    //nom du produit
    private _productName: string = null;

    // texte constitué des compositions affichées
    private _productCompositionsText: string | null = null;

    //indique si on dissimule le tooltip produit sur la composition
    private _hiddenTooltip: boolean = false;

    //css de la div
    public basicDivClass = this._basicDivClassHover;

    //css additionel à la div selon données
    public addDivClass = "";

    //id de la div
    public idDivCompo = this.GenerateDivId();

    /**Retourne le texte formaté  des compositions*/
    get ProductCompositionsText() {
        return `${this._productCompositionsText}`;
    }

    /**Retourne l'unité de compositions*/
    public get ProductCompoUnitText() {
        return this._compoUnit;
    }

    //Retourne le tooltip formaté sur la div
    get PopinTooltip() {
        if (!this._hiddenTooltip) {
            if (!isNullOrEmptyString(this._productName)) {
                return `${this._pfxTooltip} :  ${this._productName}`;
            } else {
                return this._pfxTooltip;
            }
        } else{
            return null;
        }
    }

    //#region Données en entrée

    /**
 * Paramètre indiquant que l'on masque le tooltip "composition du produit"
 * OPTION
 */
    @Input()
    set HiddenProductTooltip(_iHiddenTooltip: boolean) {
        if (!isNullOrUndefined(_iHiddenTooltip)) {
            this._hiddenTooltip = _iHiddenTooltip;
        }
    }

    /**
     * Paramètre indiquant que l'on affiche les teneurs à zero aussi
     * IMPERATIF de le passer AVANT ProductCompositions
     * OPTION
     */
    @Input()
    set IncludeNoneCompo(_iIncludeNoneCompo: boolean) {
        if (_iIncludeNoneCompo && _iIncludeNoneCompo == true) {
            this._onlyWithCompo = false;
        }
    }

    /**
   * Paramètre indiquant que l'on affiche les teneurs à zero aussi
   * 
   */
    @Input()
    set IdDiv(_iIdDivCompo: string) {
        if (_iIdDivCompo && !isNullOrUndefined(_iIdDivCompo)) {
            this.idDivCompo = _iIdDivCompo;
        }
    }

    /**
     * Paramètre indiquant si on force les composition à zero de les afficher
     * IMPERATIF de le passer AVANT ProductCompositions
     * OPTION
     */
    @Input()
    set ForceOnEmpty(_iForceOnEmpty: boolean) {
        if (_iForceOnEmpty && _iForceOnEmpty == true) {
            this._forceOnEmpty = true;
        }
    }


    /**Nom du produit concerné affiché en tooltip 
     * OPTION
    */
    @Input()
    set ProductName(_iProductName: string) {
        if (typeof (_iProductName) == 'string' && !isNullOrUndefined(_iProductName)) {
            this._productName = _iProductName;
        } else {
            this._productName = "";
        }
    }

    /**unité du produit concerné conditionnera l'unité de composition (cas des litres) */
    @Input()
    set ProductUnit(_iProductUnit: string) {
        this._compoUnit = this._compoMassUnit;
        if (typeof (_iProductUnit) == 'string' && !isNullOrUndefined(_iProductUnit)) {
            if (["L", "M3"].includes(_iProductUnit.trim().toUpperCase())) {
                this._compoUnit = this._compoLiquidUnit;
            }
        }
    }

    /**
     * Teneurs du produit (filtré les teneurs à 0 selon config)
     */
    @Input()
    set ProductCompositions(_iCompositions: any[]) {
        this.BindCompoText(_iCompositions);
    }

    /** Indique si on affiche la popin pleine (donc hors process hover) 
     * OPTION
    */
    @Input()
    set Deployed(_isetDeployed: boolean) {
        if (_isetDeployed && _isetDeployed == true) {
            this.addDivClass = ""
            this.basicDivClass = "popin-compo-deployed";
        }
    }
    //#endregion


    ngOnInit() {
    };

    /**
     * Constitution de la liste des teneurs affichées selon les paramétrages
     * @param _iCompositions 
     */
    private BindCompoText(_iCompositions: any) {
        this._productCompositionsText = "";
        this.addDivClass = "";

        let oCompo: string[] = [];
        if (_iCompositions != null && Object.keys(_iCompositions).length) {

            this._orderedCompos.forEach((fCompo: string) => {
                if (!isNullOrUndefined(_iCompositions[fCompo]) && (!this._onlyWithCompo || _iCompositions[fCompo] > 0)) {
                    oCompo.push(`${fCompo} : ${HandleService.NumberToForceFrString(_iCompositions[fCompo])}`);
                } else if (this._forceOnEmpty) {
                    if (!isNullOrUndefined(_iCompositions[fCompo])) {
                        oCompo.push(`${fCompo} : 0`);
                    } else {
                        oCompo.push(`${fCompo} : ${this._noneCompoValue}`);
                    }

                }
            });

        } else if (this._forceOnEmpty) {
            this._orderedCompos.forEach((fCompo: string) => {
                oCompo.push(`${fCompo} :  ${this._noneCompoValue}`);
            });
        }
        let separator = " | ";
        this._productCompositionsText = oCompo.join(separator);
    }

    /**
     * Génération d'un id unique de div
     * @returns 
     */
    private GenerateDivId() {
        return 'idDvPopProductCompositions_';
    }

}